export default __webpack_public_path__ + "static/media/cleaning.cb0956d7.png";